import utils from "./utils";

class FormFilters {
	options = (formId) => {
		if (formId === 'ny3848') {
			return [{column: 'created_on', displayName: 'Date', type: 'datetime'}]
		}
		if (formId === 'dea41') {
			return [{column: 'created_on', displayName: 'Date', type: 'datetime'}]
		}
	};

	defaultFilter = (formId) => {
		if (formId === 'ny3848') {
			const {startDate, endDate} = getSemiAnnualDates();
			return [
				{ displayName:'Start', name: utils.display_date(startDate), value: { datetime: (startDate).toISOString(), operator: '>' }, column: 'created_on' },
				{ displayName:'End', name: utils.display_date(new Date(endDate)), value: { datetime: (new Date(endDate)).toISOString(), operator: '<' }, column: 'created_on' },
			]
		}
		if (formId === 'dea41') {
			const endDate = new Date();
			const startDate = new Date();
			startDate.setMonth(startDate.getMonth() - 1);
			return [
				{ displayName:'Start', name: utils.display_date(startDate), value: { datetime: startDate.toISOString(), operator: '>' }, column: 'created_on' },
				{ displayName:'End', name: utils.display_date(endDate), value: { datetime: endDate.toISOString(), operator: '<' }, column: 'created_on' },
			]
		}
	}
}
const formFilters = new FormFilters();
export default formFilters;
function getSemiAnnualDates(currentDate = new Date()) {
	const year = currentDate.getFullYear();
	const june30 = new Date(`06/30/${year}`);
	const dec31 = new Date(`12/31/${year}`);

	if (currentDate > june30) {
		return {
			endDate: june30,
			startDate: new Date(`12/31/${year - 1}`),
		};
	} else {
		return {
			endDate: dec31,
			startDate: june30,
		};
	}
}


// WEBPACK FOOTER //
// ./src/utils/formFilters.js